// Função getQuantityIncrement
// Propósito: Calcula e normaliza o valor de incremento de quantidade para um produto, garantindo um fallback seguro quando o valor não está definido ou é inválido.
// Lógica passo a passo:
// Recebe um objeto product (tipado como any, mas espera propriedades como quantity_increment e un para unidade).
// Converte quantity_increment para número se for string (usando parseFloat).
// Se o valor for null, 0, undefined ou NaN, aplica um fallback baseado na unidade (un):
// Para unidades em KG (maiúsculo), retorna 0.1 (representando 100g, comum para produtos a granel).
// Para outras unidades, retorna 1 (incremento de 1 unidade).
// Caso contrário, retorna o valor específico de quantity_increment.
// Comentários no código: Indicam que é para produtos com quantity_increment e unidade, e explicam os fallbacks (ex.: "0.1 para Kg quando null/0").
// Exemplo de uso implícito: Permite incrementos granulares para produtos pesáveis (ex.: adicionar 0.1kg de carne) vs. discretos para itens unitários (ex.: adicionar 1 maçã).

export function getQuantityIncrement(product: any): number {
  let quantityIncrement = product?.quantity_increment;

  // Converte para número se for string
  if (typeof quantityIncrement === 'string') {
    quantityIncrement = parseFloat(quantityIncrement);
  }

  // Verifica se é null, 0, undefined ou NaN
  if (quantityIncrement == null || quantityIncrement === 0 || isNaN(quantityIncrement)) {
    // Fallback baseado na unidade
    if (product?.un === 'KG') {
      return 0.1; // 0.1 para KG quando null/0
    } else {
      return 1; // Para outras unidades
    }
  }

  // Retorna o valor específico
  return quantityIncrement;
}